import { Typography } from '@sunwebgroup/uds-ui/typography'
import { useIntl } from '@/intl'
import { useConfiguration } from '@/scopes/common/infrastructure/config/ConfigProvider'
import { getBankTransferDetails } from '@/scopes/payment/domain/policies/bankTransferDetails'
import styles from './BankTransferDetails.module.css'

export function BankTransferDetails() {
  const { formatMessage } = useIntl()
  const siteName = useConfiguration('siteName')
  const details = getBankTransferDetails(siteName)

  return (
    <div className={styles.wrapper}>
      <Typography variant="body-s-bold-tight">
        {formatMessage(
          { id: 'payment_scope_method_banktransfer_info_title' },
          {
            allowedDaysBeforeDeparture: details?.allowedDaysBeforeDeparture ?? null,
          },
        )}
      </Typography>
      <Typography variant="body-s-regular-tight">
        {formatMessage(
          { id: 'payment_scope_method_banktransfer_info_body' },
          {
            transferBankNumber: details?.transferBankNumber ?? '',
            beneficiaryName: details?.beneficiaryName ?? '',
            bankName: details?.bankName ?? '',
            bankIdentifier: details?.bankIdentifier ?? '',
            bicCode: details?.bicCode ?? '',
            ibanNumber: details?.ibanNumber ?? '',
            allowedDaysBeforeDeparture: details?.allowedDaysBeforeDeparture ?? null,
          },
        )}
      </Typography>
    </div>
  )
}
